/**
 * Storefront session helper.
 * Runs after cart updates; never blocks cart operations.
 */
(function () {
  'use strict';

  var VISITOR_STORAGE_KEY = 'wf_lp_visitor_id';
  var DEDUPE_PREFIX = 'wf_session_sent:';
  var REQUEST_TIMEOUT_MS = 2000;
  var inFlight = false;

  function getEndpointUrl() {
    try {
      var settings = window.theme && theme.settings ? theme.settings : null;
      var base = settings && settings.cartIpBeaconUrl ? String(settings.cartIpBeaconUrl).trim() : '';
      if (!base) return '';
      return base.replace(/\/$/, '') + '/session';
    } catch (e) {
      return '';
    }
  }

  function generateUuid() {
    var d = Date.now();
    if (window.performance && typeof window.performance.now === 'function') {
      d += performance.now();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  function getVisitorId() {
    try {
      var existing = localStorage.getItem(VISITOR_STORAGE_KEY);
      if (existing) return existing;
      var id = generateUuid();
      localStorage.setItem(VISITOR_STORAGE_KEY, id);
      return id;
    } catch (e) {
      if (!window.__wfVisitorId) window.__wfVisitorId = generateUuid();
      return window.__wfVisitorId;
    }
  }

  function normalizeCartToken(token) {
    if (!token) return '';
    var value = String(token).trim();
    var q = value.indexOf('?');
    return q === -1 ? value : value.slice(0, q);
  }

  function getCartJsUrl() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root + 'cart.js';
    }
    if (window.theme && theme.routes && theme.routes.cart) {
      return theme.routes.cart + '.js';
    }
    return '/cart.js';
  }

  function alreadySent(cartToken) {
    try {
      return sessionStorage.getItem(DEDUPE_PREFIX + cartToken) === '1';
    } catch (e) {
      return false;
    }
  }

  function markSent(cartToken) {
    try {
      sessionStorage.setItem(DEDUPE_PREFIX + cartToken, '1');
    } catch (e) {}
  }

  function abortSignal(ms) {
    if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function') {
      return AbortSignal.timeout(ms);
    }
    if (typeof AbortController === 'undefined') return undefined;
    var controller = new AbortController();
    setTimeout(function () {
      try {
        controller.abort();
      } catch (e) {}
    }, ms);
    return controller.signal;
  }

  /** Fire-and-forget; must never be awaited by cart handlers. */
  function syncSession() {
    var url = getEndpointUrl();
    if (!url || inFlight) return;

    inFlight = true;

    fetch(getCartJsUrl(), { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        var cartToken = normalizeCartToken(cart && cart.token ? cart.token : '');
        if (!cartToken) return;

        if (alreadySent(cartToken)) return;

        var payload = JSON.stringify({
          cart_token: cartToken,
          visitor_id: getVisitorId()
        });

        markSent(cartToken);

        return fetch(url, {
          method: 'POST',
          mode: 'cors',
          keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: payload,
          signal: abortSignal(REQUEST_TIMEOUT_MS)
        }).then(function (res) {
          if (!res || !res.ok) {
            try {
              sessionStorage.removeItem(DEDUPE_PREFIX + cartToken);
            } catch (e) {}
          }
        });
      })
      .catch(function () {})
      .then(function () {
        inFlight = false;
      });
  }

  function onCartEvent() {
    try {
      setTimeout(syncSession, 0);
    } catch (e) {
      try {
        syncSession();
      } catch (e2) {}
    }
  }

  document.addEventListener('on:cart:add', onCartEvent);
  document.addEventListener('on:cart:change', onCartEvent);
})();
